<template>
  <div>
    <div v-if="!isReady" class="waitingIcon">
      <icon class="iconClass" name="spinner" scale="2" spin></icon>
      <!-- <icon class="iconClass" name="sync" spin></icon> -->
    </div>
    <div v-if="isReady" id="appFrame">
      <navigation ></navigation>
      <router-view/>
    </div>
  </div>
</template>

<script>
import { app } from '@/firebase'
import { db } from '@/firebase'
import bus from '@/bus.js'
import Navigation from '@/components/Navigation.vue'
export default {
  data () {
    return {
      isReady: false
    }
  },
  components: {
    'navigation': Navigation
  },
  created(){
    bus.$on('roomIdReady', data => {
      this.isReady = true
      // alert('room is ready')
    })
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
body {
  height: 100%;
}

#appFrame {

  /* position: relative; */
  /* background-color: orange; */
  /* max-width: 500px; */
  margin: 0 auto;
  /* border: 1px solid rgba(0, 0, 0, 0.5); */
  /* min-height: 400px; */

}
.navSticky {
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 200;
}

.iconClass {
  /* margin: 140px; */
}

.waitingIcon {
  border-radius: 4px;
  width: 100px;
  height: 100px;
  /* background-color: orange; */

  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  margin: auto;
}

@media screen and (min-width: 455px) {
  #appFrame {
    position: absolute;
    bottom: 0px;
    top: 0px;
    left: 0px;
    right: 0px;
    overflow: auto;
    box-shadow: 0px 10px 20px 5px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    max-width: 450px;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/landingPage.vue